import { useEffect, useState } from "react";
import {
  Button,
  Col,
  Flex,
  Row,
  Space,
  Table,
  Tag,
  Tooltip,
  Typography,
} from "antd";
import { EditOutlined } from "@ant-design/icons";
import {
  callCreateDashboardPayMethods,
  callGetDashboardPayMethods,
  callUpdateDashboardPayMethods,
} from "../../../../../services/paymentService";
import { maskCard, showNotificationTopEnd } from "../../../../../util/utils";
import PayMethodCreateForm from "../PayMethodModalForm/PayMethodModalForm";
import { DASHBOARD_PAY_METHODS } from "../../../../../constants/AppConstants";

import "./PayMethodList.css";

const { Title } = Typography;

export default function PayMethodsList() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [modalCreateVisible, setModalCreateVisible] = useState(false);
  const [reload, setReload] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const getPaymentMethods = async (page, size) => {
    setLoading(true);

    const response = await callGetDashboardPayMethods(page, size);
    if (response?.status === 200) {
      setData(response.data.content);
      setPagination({
        current: page + 1,
        pageSize: size,
        total: response.data?.page?.totalElements,
      });
    } else {
      showNotificationTopEnd("error", "Error, por favor recarga la pagina");
    }
    setLoading(false);
  };

  useEffect(() => {
    getPaymentMethods(pagination.current - 1, pagination.pageSize);
    // eslint-disable-next-line
  }, [reload]);

  const handleTableChange = (pagination) => {
    getPaymentMethods(pagination.current - 1, pagination.pageSize);
  };

  const handleEdit = (record) => {
    setSelectedRecord(record);
    setModalCreateVisible(true);
  };

  const columns = [
    {
      title: DASHBOARD_PAY_METHODS.COLUMNS.ID,
      dataIndex: "payMethodId",
      key: "payMethodId",
      width: 80,
    },
    {
      title: DASHBOARD_PAY_METHODS.COLUMNS.BANK,
      dataIndex: "bank",
      key: "bank",
    },
    {
      title: DASHBOARD_PAY_METHODS.COLUMNS.NAME,
      dataIndex: "owner",
      key: "owner",
    },
    {
      title: DASHBOARD_PAY_METHODS.COLUMNS.CARD_NUMBER,
      dataIndex: "cardNumber",
      key: "cardNumber",
      render: (value) => maskCard(value),
    },
    {
      title: DASHBOARD_PAY_METHODS.COLUMNS.STATUS,
      dataIndex: "active",
      key: "active",
      render: (value) =>
        value ? (
          <Tag color="green">{DASHBOARD_PAY_METHODS.STATUS.ACTIVE}</Tag>
        ) : (
          <Tag color="red">{DASHBOARD_PAY_METHODS.STATUS.INACTIVE}</Tag>
        ),
    },
    {
      title: DASHBOARD_PAY_METHODS.COLUMNS.ACTIONS,
      key: "active",
      render: (_, record) => (
        <Space>
          <Tooltip title={DASHBOARD_PAY_METHODS.ACTIONS.TOOLTIPS.EDIT}>
            <Button
              shape="circle"
              icon={<EditOutlined />}
              type="primary"
              onClick={() => handleEdit(record)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <Flex vertical>
      <Row
        gutter={[16, 16]}
        justify="space-between"
        align="middle"
        style={{ marginBottom: 24 }}
      >
        <Col span="auto">
          <Title level={3}>{DASHBOARD_PAY_METHODS.TITLE}</Title>
        </Col>
        <Col span="auto">
          <Button
            // className="add-button"
            color="green"
            variant="solid"
            onClick={() => setModalCreateVisible(true)}
          >
            {DASHBOARD_PAY_METHODS.ACTIONS.CREATE_TITLE}
          </Button>
          <PayMethodCreateForm
            visible={modalCreateVisible}
            onClose={() => {
              setModalCreateVisible(false);
              setSelectedRecord(null);
              setReload(!reload);
            }}
            initialValues={selectedRecord}
            onSubmit={(values) =>
              selectedRecord
                ? callUpdateDashboardPayMethods(values)
                : callCreateDashboardPayMethods(values)
            }
          />
        </Col>
      </Row>
      <Table
        columns={columns}
        dataSource={data}
        rowKey="payMethodId"
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
      />
    </Flex>
  );
}
